import React, { useContext, useEffect, useState } from "react";
import UserContext from "../Contexts/UserContext";
import { Navigate, useLocation } from "react-router-dom";
import { containsAll } from "wup-module1-base";
import { ProcessStatusEnum, RoutePathConstants } from "../Constants";
import { SurveyService, ClientService } from "../Services";
import { M1_FormApplicationStatuses } from "../Constants";

function ProtectedRoute({
  children,
  requiredPermissions = [],
  validateStep = false,
}) {
  const location = useLocation();
  const [isSurveyActiveInTerms, setIsSurveyActiveInTerms] = useState(false);
  const [isSecondOrderAvailable, setIsSecondOrderAvailable] =  useState(false);
  const [isProjectMember, setIsProjectMember] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const navigateToHome = () => {
    const currentPath = window.location.pathname.replace("/m1", "");
    const currentPathStep = getCurrentStepByPath(currentPath);

    if(currentPathStep === ProcessStatusEnum.CompletingBalanceSheetOfModuleSecondv2 && !user.isSecondOrderAvailable){
      return <Navigate to={"/"} />
    }

    if (
      currentPathStep === ProcessStatusEnum.ApplicationForm.value &&
      user.isFirstRecrutation
    ) {
      return <Navigate to={"/"} />;
    }

    if (currentPathStep === ProcessStatusEnum.Survey.value) {
      if (!user.isSurveyActive && currentPathStep < 8 && currentPathStep > 0) {
        return <Navigate to={"/"} />;
      }
    }

    if (
      user.currentStep === ProcessStatusEnum.Store.value &&
      currentPathStep === ProcessStatusEnum.StoreSummary.value
    ) {
      return children;
    }
    if (user.currentStep < currentPathStep) {
      return <Navigate to={"/"} />;
    }
    return children;
  };

  const getCurrentStepByPath = (path) => {
    if (
      path.includes(`/${RoutePathConstants.StoreExclusive}/`) ||
      path.includes(`/${RoutePathConstants.StoreExclusiveSummary}/`)
    ) {
      return ProcessStatusEnum.StoreExclusive.value;
    }
    if (path.includes(`/ApplicationForm`)) {
      return ProcessStatusEnum.ApplicationForm.value;
    }

    path = path.toLowerCase();

    switch (path) {
      case `/${RoutePathConstants.Survey.toLowerCase()}`:
        return ProcessStatusEnum.Survey.value;
      case `/${RoutePathConstants.ApplicationForm.toLowerCase()}`:
        return ProcessStatusEnum.ApplicationForm.value;
      case `/${RoutePathConstants.ContractFormv2.toLowerCase()}`:
        return ProcessStatusEnum.ContractFormv2.value;
      case `/${RoutePathConstants.ContractForm.toLowerCase()}`:
        return ProcessStatusEnum.ContractForm.value;
      case `/${RoutePathConstants.CompletingBalanceSheetOfModuleFirst.toLowerCase()}`:
        return ProcessStatusEnum.CompletingBalanceSheetOfModuleFirst.value;
      case `/${RoutePathConstants.CompletingBalanceSheetOfModuleFirstByAdvisor.toLowerCase()}`:
        return ProcessStatusEnum.CompletingBalanceSheetOfModuleFirstByAdvisor
          .value;
      case `/${RoutePathConstants.Store.toLowerCase()}`:
        return ProcessStatusEnum.Store.value;
      case `/${RoutePathConstants.StoreSummary.toLowerCase()}`:
        return ProcessStatusEnum.StoreSummary.value;
      case `/${RoutePathConstants.StoreEdit.toLowerCase()}`:
        return ProcessStatusEnum.StoreEdit.value;
      case `/${RoutePathConstants.CompletingBalanceSheetOfModuleSecond.toLowerCase()}`:
        return ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond.value;
      case `/${RoutePathConstants.CompletingBalanceSheetOfModuleSecondv2.toLowerCase()}`:
          return ProcessStatusEnum.CompletingBalanceSheetOfModuleSecondv2.value;
      case `/${RoutePathConstants.OrderingVouchers.toLowerCase()}`:
        return ProcessStatusEnum.OrderingVouchers.value;
      default:
        return ProcessStatusEnum.Survey.value;
    }
  };

  useEffect(() => {
    if (!user.isSecondOrderAvailable) {
      SurveyService.checkIsSecondOrderAvailable(user.id)
      .then((response) => {
       setIsSecondOrderAvailable(response.data.canOrder);
      })
      .catch((error) => {
        console.error(error);
      });
    }

    if (!user.isSurveyActive) {
      // sprawdzenie czy klient zakończył formularz zgłoszeniowy
      ClientService.fetchClientEntity(user.id)
        .then((response) => {
          if (
            response.data.register_status ===
              M1_FormApplicationStatuses.ResendAnnouncement.value ||
            response.data.register_status ===
              M1_FormApplicationStatuses.ProjectMember.value
          ) {
            setIsProjectMember(true);
          } else {
            setIsProjectMember(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });

      // sprawdzenie czy autoanaliza jest dostępna
      SurveyService.checkIsSurveyActive(1, user.id)
        .then((response) => {
          setIsSurveyActiveInTerms(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  // hook ustawiający w context usera, czy klient może zamówic bony
  useEffect(() => {
    if (!!isSecondOrderAvailable) {
      setUser((prevUser) => ({
        ...prevUser,
        isSecondOrderAvailable: isSecondOrderAvailable,
      }));
    }
  }, [isSecondOrderAvailable]);

  // hook ustawiający w context usera, czy autoanaliza jest dostępna
  useEffect(() => {
    if (isProjectMember === true && !!isSurveyActiveInTerms) {
      setUser((prevUser) => ({
        ...prevUser,
        isSurveyActive: isSurveyActiveInTerms.isActive,
        surveyValidationDate: isSurveyActiveInTerms.dateTo,
      }));
    }
  }, [isProjectMember, isSurveyActiveInTerms]);

  useEffect(() => {
    if (location.pathname.includes("exclusive-offer")) {
      sessionStorage.setItem("lastExclusiveOfferPath", location.pathname);
    }
  }, [location]);

  return !user.id || !containsAll(user.permissions, requiredPermissions) ? (
    <Navigate to={`/login`} />
  ) : validateStep ? (
    navigateToHome()
  ) : (
    children
  );
}

export default ProtectedRoute;
